import React, { useState } from "react";
import { Labeled, useDataProvider, useGetList, useNotify, Button } from "react-admin";
import { Box, Checkbox, FormGroup, FormControlLabel, TextField as TextInput, Typography } from "@mui/material";
import ModeEditIcon from "@mui/icons-material/ModeEdit";

import { settings } from "app";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import { specialistRequests } from "api/specialistApi";
import { administrationRequests } from "api/administrationApi";

const ReturnForCorrectionModal = ({ item, getDetails }) => {
  const [selectedPersonalInfoFields, setPersonalInfoFields] = useState([]);
  const [selectedDocumentTypeIds, setSelectedDocumentTypeIds] = useState([]);
  const [message, setMessage] = useState(null);
  const dataProvider = useDataProvider();
  const notify = useNotify();

  const { data: documentTypes } = useGetList(
    administrationRequests.getPreferenceDocumentTypesSelect(),
    {
      filter: { ids: item?.documents.map(x => x?.documentTypeId) },
    },
    { enabled: !!item?.documents },
  );
  const { data: specialityName } = useGetList(
    administrationRequests.getSpecialitiesSelect(),
    {
      filter: { ids: item?.graduationInfo.specialityId },
    },
    { enabled: !!item?.graduationInfo.specialityId },
  );
  const { data: degreeName } = useGetList(
    administrationRequests.getDegreesSelect(),
    {
      filter: { ids: item?.graduationInfo.degreeId },
    },
    { enabled: !!item?.graduationInfo.degreeId },
  );
  const { data: birthSettlementName } = useGetList(
    administrationRequests.getSettlementsSelect(),
    {
      filter: { ids: item?.graduationInfo.birthSettlementId },
    },
    { enabled: !!item?.graduationInfo.birthSettlementId },
  );

  const { data: birthCountryName } = useGetList(
    administrationRequests.getCountriesSelect(),
    {
      filter: { ids: item?.graduationInfo.birthCountryId },
    },
    { enabled: !!item?.graduationInfo.birthCountryId },
  );
  const { data: primaryCountryName } = useGetList(
    administrationRequests.getCountriesSelect(),
    {
      filter: { ids: item?.graduationInfo.primaryCitizenshipCountryId },
    },
    { enabled: !!item?.graduationInfo.primaryCitizenshipCountryId },
  );
  const { data: secondaryCountryName } = useGetList(
    administrationRequests.getCountriesSelect(),
    {
      filter: { ids: item?.graduationInfo.secondaryCitizenshipCountryId },
    },
    { enabled: !!item?.graduationInfo.secondaryCitizenshipCountryId },
  );
  const personalInfoFields = [
    { id: 5, value: item?.user?.firstName, label: "Име" },
    { id: 6, value: item?.user?.secondName, label: "Презиме" },
    { id: 7, value: item?.user?.lastName, label: "Фамилия" },
    { id: 8, value: item?.user?.personId, label: "ЕГН" },
    { id: 9, value: item?.user?.contactPhone, label: "Телефон за контакт" },
    { id: 11, value: item?.user?.birthDate, label: "Дата на раждане" },
    {
      id: 10,
      value: item?.user?.gender === 1 ? "Мъж" : "Жена",
      label: "Пол",
    },

    {
      id: 2,
      value: item?.graduationInfo?.university,
      label: "Университет",
    },
    {
      id: 4,
      value: item?.qualificationRecognitionCert,
      label: "Удостоверение за признаване на квалификация",
    },
    {
      id: 3,
      value: item?.higherEducationRecognitionCert,
      label: "Удостоверение за признаване на висше образование",
    },
    {
      id: 21,
      value: item?.graduationInfo.diplomaDate,
      label: "Дата за дипломиране",
    },
    {
      id: 20,
      value: item?.graduationInfo.diplomaNumber,
      label: "Номер на диплома",
    },
    {
      id: 18,
      value: item?.graduationInfo.diplomaRegistrationNumber,
      label: "Рег. Номер на диплома",
    },
    {
      id: 19,
      value: item?.graduationInfo.diplomaSeries,
      label: "Диплома серия",
    },
    {
      id: 16,
      value: specialityName?.[0]?.name,
      label: "Специалност",
    },
    {
      id: 17,
      value: degreeName?.[0]?.name,
      label: "Научна степен",
    },
    {
      id: 13,
      value: birthSettlementName?.[0]?.name,
      label: "Населено място на раждане",
    },
    {
      id: 12,
      value: birthCountryName?.[0]?.name,
      label: "Държава на раждане",
    },
    {
      id: 14,
      value: primaryCountryName?.[0]?.name,
      label: "Основно гражданство",
    },
    {
      id: 15,
      value: secondaryCountryName?.[0]?.name,
      label: "Второ гражданство",
    },
  ];

  const documents = documentTypes?.map(x => {
    return { id: x?.id, label: x?.name } || null;
  });

  const handleConfirm = async () => {
    if (!message) {
      notify("Моля въведете бележка!", { type: "warning" });
      return false;
    }

    const data = {
      note: message,
      personalInfoFields: selectedPersonalInfoFields,
      documentTypeIds: selectedDocumentTypeIds,
    };

    await dataProvider.customRequest(
      specialistRequests.postSpecialistsApplicationCorrectionFields({ campaignId: item.campaignId, id: item.id }),
      data,
      "POST",
    );
    notify("Успешно изпратена заявка за корекция.", { type: "success" });
    getDetails();
  };

  const handleChange = (id, type = "default") => {
    if (type === "doc") {
      setSelectedDocumentTypeIds(prev => (prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]));
    } else {
      setPersonalInfoFields(prev => (prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]));
    }
  };
  const resetState = () => {
    setPersonalInfoFields([]);
    setSelectedDocumentTypeIds([]);
    setMessage(null);
  };
  return (
    <Box
      display="flex"
      justifyContent="flex-end"
    >
      <ConfirmModal
        triggerButton={
          <Button
            variant="contained"
            color="inherit"
            size="medium"
            startIcon={<ModeEditIcon />}
            label="Върни кандидатура за корекция"
          />
        }
        titleContent="Моля отбележете полетата които да бъдат върнати за корекция"
        saveTitle="Изпрати"
        closeTitle="Откажи"
        onConfirm={handleConfirm}
        resetProps={resetState}
        confirmEnabled={selectedPersonalInfoFields?.length > 0 || selectedDocumentTypeIds?.length > 0}
        dialogProps={{
          sx: {
            "& .MuiDialog-paper": {
              textAlign: "center",
              minWidth: "60%",
            },
            "& .MuiDialogContent-root": {
              overflowY: "auto !important",
              overflowX: "hidden !important",
            },
          },
        }}
      >
        {personalInfoFields.length > 0 ? (
          <FormGroup
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
              gap: ".5rem",
              marginBottom: "1.5em",
              ...settings.style.shadowBox,
            }}
          >
            {personalInfoFields?.map(x => (
              <Labeled
                key={x.id}
                label={x.label}
                sx={{
                  textAlign: "left",
                  gridColumn: "auto",
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedPersonalInfoFields.includes(x.id)}
                      onChange={() => handleChange(x.id)}
                    />
                  }
                  label={x.value}
                />
              </Labeled>
            ))}
          </FormGroup>
        ) : null}
        <FormGroup
          sx={{
            gap: ".5rem",
            marginBottom: "1.5em",
            ...settings.style.shadowBox,
          }}
        >
          <Typography
            sx={{
              textAlign: "left",
            }}
          >
            Избрани документи
          </Typography>
          {documents?.map(x => (
            <FormControlLabel
              key={x.id}
              control={
                <Checkbox
                  checked={selectedDocumentTypeIds.includes(x.id)}
                  onChange={() => handleChange(x.id, "doc")}
                />
              }
              label={x.label}
            />
          ))}
        </FormGroup>

        <TextInput
          label="Въведи съобщение"
          multiline
          variant="outlined"
          onChange={e => setMessage(e.target.value)}
          inputProps={{ maxLength: 2000 }}
          helperText={`${message?.length || 0}/2000`}
          error={(message?.length || 0) > 2000}
          maxRows={6}
          minRows={4}
          fullWidth
        />
      </ConfirmModal>
    </Box>
  );
};
export default ReturnForCorrectionModal;
